import { motion } from "framer-motion";
import { Truck, ShieldCheck, Flame, RotateCcw } from "lucide-react";

const FEATURES = [
  { icon: Truck, title: "Fast Fulfilment", desc: "Printed & shipped in 2-5 days via Printful" },
  { icon: ShieldCheck, title: "Heavyweight Quality", desc: "240 GSM combed cotton fabric" },
  { icon: Flame, title: "Fierce Tiger Prints", desc: "High-density DTG crisp graphics" },
  { icon: RotateCcw, title: "Easy Returns", desc: "30-day hassle-free exchanges" },
];

export const BrandFeatures = () => {
  return (
    <section data-testid="features-section" className="border-y border-zinc-200 bg-fog py-14">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 sm:grid-cols-2 sm:px-8 lg:grid-cols-4 lg:px-12">
        {FEATURES.map((feature, i) => (
          <motion.div
            key={feature.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            data-testid={`feature-${feature.title.toLowerCase().replace(/\s+/g, "-")}`}
            className="flex items-start gap-4"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-tiger/40 bg-tiger/10 text-tiger">
              <feature.icon size={22} />
            </span>
            <div>
              <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-zinc-900">{feature.title}</h3>
              <p className="mt-1 font-body text-xs leading-relaxed text-zinc-500">{feature.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
